import api from '../utils/api';
import {
  HEALTH_DATA_FAILED,
  HEALTH_DATA_SUCCESS,
  REQUEST_HEALTH_DATA,
} from './types';

export const loadHealth = (params) => async (dispatch) => {
  console.log("ParamHealth",params);
  try {
    dispatch({ type: REQUEST_HEALTH_DATA });
    const { data } = await api.get(`/data/health?${params}`);
    dispatch({ type: HEALTH_DATA_SUCCESS, payload: data.data });
  } catch (error) {
    console.log(error);
    dispatch({ type: HEALTH_DATA_FAILED });
  }
};

export const clearHealth = ()=> async(dispatch)=>{
  try{
    dispatch({type:HEALTH_DATA_SUCCESS, payload:null})
  }catch(err){
    console.log(err)
  }
}

export const loadHealt =
  (user, building, floor, room, between) => async (dispatch) => {
    try {
      let body = {
        gauges: [
          {
            name: 'Temperature',
            label: 'Temperature',
            arcsLength: '0.2,0.2,0.4,0.2,0.2',
            colors: 'blue,DeepSkyBlue,lawngreen,#ffff00,#f00',
            unit: '°C',
            max: 48,
          },
          {
            name: 'AQI',
            label: 'Air Quality',
            arcsLength: '0.1,0.1,0.1,0.2,0.4',
            unit: '',
            max: 500,
          },
          {
            name: 'Relative_Humidity',
            label: 'Humidity',
            colors: 'gold,lawngreen,DeepSkyBlue',
            unit: '%',
            max: 100,
          },
        ],
        multi_graph: [
          {
            name: 'PM1',
            label: 'Particles 1mm',
            color: 'Red',
            unit: 'μ g/m ³',
            exponential: false,
          },
          {
            name: 'PM10',
            label: 'Particles 10mm',
            color: 'Green',
            unit: 'μ g/m ³',
            exponential: false,
          },
          {
            name: 'PM25',
            label: 'Particles 2.5mm',
            color: '#FFC328',
            unit: 'μ g/m ³',
            exponential: false,
          },
        ],
        graphs: [
          {
            name: 'Noise_Level',
            label: 'Noise Level',
            color: '#FEC14B',
            unit: 'db',
            exponential: true,
          },
          {
            name: 'Light',
            label: 'Light',
            color: '#2BDF9E',
            unit: 'lx',
            exponential: true,
          },
          {
            name: 'Gas_Resistance',
            label: 'Gas Resistance',
            color: '#FEC14B',
            unit: 'Ω',
            exponential: true,
          },
        ],
        email: user,
        between,
        floor,
        building,
        room,
      };
      console.log(body);
      dispatch({ type: REQUEST_HEALTH_DATA });
      const { data } = await api.post(`/health`, body);
      console.log(data);
      dispatch({ type: HEALTH_DATA_SUCCESS, payload: data });
    } catch (error) {
      console.log(error);
      dispatch({ type: HEALTH_DATA_FAILED });
    }
  };
